// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "footage_treatment".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "footage_treatment" table (1:1 with a DB row, on the wire). */
export const footageTreatmentAtomSchema = z.object({
    slug: z.string(),
    displayName: z.string(),
    techniqueSlug: z.string(),
    parentSlug: z.string().nullable(),
    agentSlug: z.string().nullable(),
    kind: z.string(),
    aliases: z.array(z.string()),
    isActive: z.boolean(),
});
//# sourceMappingURL=footageTreatment.js.map